import { useQuery } from '@tanstack/react-query';
import { authGatewayApi } from '../../../apis/auth-gateway.api';

//Unused, need to refactor
export const useAuthGateway = (payload) => {
  return useQuery({
    queryKey: ['auth-gateway', payload.query],
    queryFn: async () => {
      if (payload.query == 'verify-otp') {
        const res = await authGatewayApi.verifyOtp(payload);
        return res;
      }
      if (payload.query == 'verify-password') {
        const res = await authGatewayApi.verifyPassword(payload);
        return res;
      }
    },
    enabled: false,
    select: (data) => data
  });
};
